import styles from '../../../ConoFuturo/ConoFuturoPA/ConoFuturo.module.css'

const PuntaFlecha = ({ style }) => {
    return (
        <div className={styles.puntaFlecha} style={{ ...style }}/>
    );
};

export default PuntaFlecha;